import {Row,Col,Card, Container} from "react-bootstrap"
import {Link} from "react-router-dom"
const Flake = () =>{
    return <div style={{padding:"2%"}}>   
    <h1>Flake - A Raspberry Ripples Expander</h1>
    <h5>additional Filter modes through the power of pole mixing:</h5>

    <ul className="flex-container">

    <li className = "flex-item" style={{width:"40rem"}}>


      <p>2 Pole High Pass</p>  
      <p>4 Pole High Pass</p>  
      <p>2 Pole Band Pass</p>  
      <p>4 Pole Band Pass</p>  
      <p>Band Pass + Notch Pass</p>  
      <p>2 Pole Notch Pass</p>  
      <p>Double Notch Pass</p>  
      <p>2 pole All pass</p>  
      <p>2 stage phaser</p>  
    
    <h3>specs</h3>
    <p>Width: 3HP (15.24mm)</p>
    <p>Height: 3U (128.5mm)</p>
    <p>Depth: ~37mm </p>
    <p>+12V: ~35mA (TBC) </p>
    <p>-12V: ~35mA (TBC)</p>

<h3>DIY</h3>
<p>IIf you have a diy kit or PCB set then check out <a href="/Flake/Build">the build guide</a></p>


<h3>How to install</h3>
<p>
  The expander connects via the 2x5 IDC connector on the back on Raspberry Ripples. This provides power and all the inputs.
</p>
</li>
<li className = "flex-item" style={{width:"15rem"}}>
  <img src={require("./Raspberry Ripples.jpg")} style={{width:"100%"}}></img>
</li>
</ul>
</div>
}

export default Flake